import React from 'react';

const MAIN_SITE = process.env.REACT_APP_MAIN_SITE_URL || 'https://keyelectrolysis.com';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          <img
            src={`${MAIN_SITE}/Logo4.png`}
            alt="Key Electrolysis Services Logo"
            className="h-24 w-auto object-contain mb-6 brightness-0 invert"
          />
          <p className="text-white/80 mb-6">Permanent Hair Removal Done With Care</p>
          <p className="text-white/60 text-sm">
            © 2025 Key Electrolysis Services Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
